import React from 'react'
import Wrapper from './notifications_components/wrapper/Wrapper'

function BackofficeNotifications () {
    return (
        <Wrapper/>
    )
}

export default BackofficeNotifications
